import Vue from "vue"
import Vuex from 'vuex'

Vue.use(Vuex)

const appSelector = document.getElementById("personalize-vue");
var state, getters, mutations, actions;

if(appSelector) {
  state = {
    pzData: [],
    initLineCode: '',
    pzFormData: []
  },
  getters = {
    
  },
  mutations = {
    setPzData:(state, payload) => {
      state.pzData = payload;
      state.initLineCode = payload.pzlines[0].style_code;
    },
    setPzFormData:(state, payload) => {
      state.pzFormData = payload;
    },
    setInitLineCode:(state, payload) => {
      state.initLineCode = payload;
    }
  },
  actions = {
    SET_PZDATA: ({ commit }, payload) => commit('setPzData', payload),
    SET_PZFORMDATA: ({ commit }, payload) => commit('setPzFormData', payload)
  }
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ../assets/js/personalize/store.js